<template>
  <default-dialog
    v-model="value"
    width="95%"
    max-width="900px" max-height="90%"
    @accepted="accepted($event)"
    @closing="closing($event) /* transmit event upward */"
    :label_accept="label_accept"
  >

    <template #header>
      <span>Sample properties</span>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <template #activator="{ on }">
          <v-icon v-on="on">mdi-cog</v-icon>
        </template>
        <template #default>
          <pre> {{ JSON.stringify(state, null, 2) }} </pre>
        </template>
      </v-tooltip>
    </template>

    <template #content>

      <v-layout row fill-height style="background-color: #EEEEFF;">

        <!-- Left pane: name, type, notes -->
        <v-flex xl8 lg8 md7 sm12 xs12 style="padding: 8px;">
          <v-layout row fill-height>

            <!-- name -->
            <v-flex xl6 lg6 md12 sm12 xs12 style="padding: 8px;">
              <v-text-field ref="edtName" v-model="inputs.name"
                            label="Sample name" outlined dense hide-details>
              </v-text-field>
            </v-flex>

            <!-- type -->
            <v-flex xl6 lg6 md12 xm12 xs12 style="padding: 8px;">
              <v-select
                v-model="inputs.type"
                label="Sample type" outlined dense hide-details
                :items="sampleType_items"
                item-value="id" item-text="name">
              </v-select>
            </v-flex>

            <!-- notes -->
            <v-flex md12 align-self-end style="padding: 8px;">
              <span>Notes</span>
              <notes-editor
                label="Notes"
                v-model="inputs.notes"
              >
              </notes-editor>
            </v-flex>

          </v-layout>

        </v-flex>

        <!-- Right pane -->
        <v-flex xl4 lg4 md5 sm12 xs12 style="padding: 8px; background-color: #EEFFEE;">
          <v-layout row style="margin: 8px;" fill-height>

            <!-- projects -->
            <v-flex md12 style="background-color: #AAFFAA;">
              <project-selector
                v-model="inputs.projects"
                height="350px"
              ></project-selector>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </template>

    <template #actions>
      <v-col>
        <v-btn ref="btnReset" @click="btnReset_click">Reset</v-btn>
      </v-col>
    </template>

  </default-dialog>

</template>

<script>

	import format from 'string-format'

	import {
		VContainer, VLayout, VRow, VCol, VFlex,
		VBtn, VTextField, VCheckBox,
	} from 'vuetify'

	import DefaultDialog from '../DefaultDialog'
	import NotesEditorComponent from '../NotesEditorComponent'
	import ProjectSelectorComponent from "../project/ProjectSelectorComponent"

	import {mapGetters} from 'vuex'

	export default {
		name: 'sample-props-dialog',
		components: {
			VContainer, VLayout, VRow, VCol, VFlex,
			VBtn, VTextField, VCheckBox,
			DefaultDialog,
			'project-selector': ProjectSelectorComponent,
			NotesEditorComponent,
		},

		data: function () {
			return {
				inputs: {
					id: null,
					name: null,
					type: null,
					notes: null,
					projects: [],
					patient: null,
					test: "hallo",
				},
			}
		},

		props: {
			value: {type: Boolean, default: false,},
			sample: {type: Object, default: () => null,},
			new: {type: Boolean, default: false,},
		},

		watch: {
			value: function () {
				// TODO: фокус на поле ввода
			},

			sample: function () {
				console.debug(format(
					"SamplePropsDialog.watch.sample( {name}, new: {new} )",
					{name: this.sample ? this.sample.name : "null", new: this.new}))

				for (let field_name in this.inputs) {
					this.inputs[field_name] = this.sample != null && field_name in this.sample
						? this.sample[field_name]
						: null
				}

				let k = 11
			},
		},

		computed: {
			...mapGetters({
				sampleType_list: 'lists/sampleType_list',
				project_list: 'lists/project_list',
			}),

			state: function () {
				return {
					new: this.new,
					inputs: this.inputs,
				}
			},

			sampleType_items: function () {
				return [{id: null, name: "<NONE>",}, ...this.sampleType_list]
			},

			label_accept: function () {
				return this.new ? "Create" : "Update"
			},
		},

		methods: {

			cleanup_data: function (val) {
				let obj = {}

				for (let key in val) {
					obj[key] = val[key]
				}

				// -1 - All projects does not exist
				obj.projects = val.projects.filter(p_id => p_id !== -1)

				if (this.new) {
					delete obj.id
				}

				return obj
			},

			/**
			 * Обработчик события нажатия пользователем кнопки Create/Update.
			 * @param event
			 */
			accepted: function (event) {
				// TODO: тут можно какие-то данные поменять
				event.inputs = this.cleanup_data(this.inputs)
				this.$emit('accepted', event)
			},

			closing: function (event) {
				this.$emit('closing', event)
			},

			btnReset_click: function (event) {

			},
		}
	}
</script>

<style>

</style>